<template>
    <header :class="['navbar np-navbar', {'collapsed':isCollapsed}]">
        <div class="row w-100">
            <div class="col-3">
                <nav aria-label="np-breadcrumb" class="np-group">
                    <ol class="np-breadcrumb mb-0">
                        <li class="np-breadcrumb-item">
                            <a href="/">
                                <svg class="icon"><use href="@/assets/images/icons/dashboard.svg#icon"></use></svg>
                            </a>
                        </li>
                        <li class="np-breadcrumb-item active" aria-current="page" v-if="company">
                            <span>{{ company.title }}</span>
                        </li>
                        <li class="np-breadcrumb-item active" aria-current="page" v-if="project && project.name">
                            <span>{{ project.name }}</span>
                        </li>                
                    </ol>
                </nav>
            </div>
            <div class="col-5">
                <SearchPanel></SearchPanel>
            </div>
            <div class="col-4">
                <div class="d-flex justify-content-end">
                    <a class="np-btn np-nav-link me-0" @click="this.$emit('toggleInviteModal')" v-if="company || project">
                        <svg><use href="@/assets/images/icons/user-add.svg#icon"></use></svg>
                    </a>
                    
                    <a class="np-btn np-nav-link me-0">
                        <svg><use href="@/assets/images/icons/notification.svg#icon"></use></svg>
                    </a>

                    <div class="np-nav-item dropdown me-0">
                        <div class="np-btn np-nav-link" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <CobaltProfile 
                                :firstName="userStore?.user?.first_name" 
                                :lastName="userStore?.user?.last_name" 
                                :avatar="userStore?.user?.imageFile" 
                                size="np-avatar-small me-2"
                                short
                            />{{ userStore.userFullName }}
                        </div>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
                            <li class="dropdown-item"><a class="btn btn-sm me-2 text-body-tertiary" @click="ShowSettings()">{{ $t("UI.sidebar.settings") }}</a></li>
                            <li class="dropdown-item"><a class="btn btn-sm me-2 text-body-tertiary" @click="UserOut()">{{ $t("auth.logout") }}</a></li>
                        </ul>                
                    </div>

                    <div class="me-2">
                        <LanguageSwitcher switcherStyle="dropdown"/>
                    </div>
                </div>
            </div>
        </div>
        <!-- 
            <a class="nav-link cobalt-toolbar__link" v-if="this.$emit('addUser')" @click="this.$emit('addUser')"><img src="@/assets/images/dashboard/member-add.svg" /></a>
        -->
    </header>

    <SettingsModal 
        modalID="modalSettings"
        ref="settingsModal" 
    />
</template>

<script>
    import { useUserStore } from '@/stores/userStore'
    import LanguageSwitcher from '../LanguageSwitcher.vue'
    import CobaltProfile from './parts/CobaltProfile.vue'
    import SettingsModal from '../modals/SettingsModal.vue'
    import SearchPanel from '../elements/SearchPanel.vue'

    export default {
        props: ['info', 'company', 'project', 'isCollapsed'],
        components: {
            LanguageSwitcher,
            CobaltProfile,
            SearchPanel,
            SettingsModal
        },
        data() {
        },
        computed: {
            userStore() {
                return useUserStore()
            }
        },
        methods: {
            toggleDashboard: function(e){          
                this.$emit('toggle')
            },
            ShowSettings() {
                this.$refs.settingsModal.shows()
            },                 
            UserOut(){
                this.userStore.logout()
                this.$router.push({ name: 'login' })
            }
        }

    }
</script>

<style></style>